// Copyright (c) Docugami, Inc. All rights reserved.

import { IconButton, Stack } from "@fluentui/react";
import { SlidingPanel } from "components/cards/SlidingPanel";
import { emptyGray, greyText, homeGray } from "components/shell/presentation/AppStyles";
import { useEffect } from "react";
import styled from "styled-components";
import { dgFontFamily } from "./Fonts";
import { FilteredCountText, ReportFilterSearchField } from "components/work_path/ReportFilterComponents";

const FilterPanelStack = styled(Stack)`
    border-top: solid 1px ${emptyGray};
    border-bottom: solid 1px ${emptyGray};
    font-family: ${dgFontFamily};
`

const FilterPanelHeader = styled(Stack)`
    height: 34px;
`

const FilterPanelHeaderText = styled.span`
    color: ${greyText};
    padding-left: 18px;
    font-size: 12px;
    font-weight: bold;
`
const FilterPanelFooter = styled(Stack)`
    font-size: 12px;
    height: 20px;
`

const FilterPanelContent = styled(Stack)`
    flex: 1;
`

interface SlidingFilterPanelProps {
    children?: React.ReactNode;
    showFilterPanel: boolean;
    filterText: string | undefined;
    onFilterTextChange: (filterText: string | undefined) => void;
    onClose: () => void;
    countText: string;
}

export const SlidingFilterPanel = (props: SlidingFilterPanelProps) => {
    useEffect(() => {
        if (!props.showFilterPanel) {
            props.onFilterTextChange('');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.showFilterPanel]);

    return (
        <SlidingPanel isOpen={props.showFilterPanel}>
            <FilterPanelStack>
                <FilterPanelHeader horizontal verticalAlign="center" horizontalAlign="space-between">
                    <FilterPanelHeaderText>FILTER</FilterPanelHeaderText>
                    <IconButton
                        iconProps={{
                            iconName: 'Cancel',
                        }}
                        styles={{
                            root: {
                                color: `${homeGray} !important`
                            }
                        }}
                        onClick={props.onClose} />
                </FilterPanelHeader>
                <FilterPanelContent horizontal horizontalAlign="stretch">
                    <ReportFilterSearchField
                        filterTargetLabel={"Item label"}
                        filterText={props.filterText}
                        onFilterTextChange={props.onFilterTextChange} />
                </FilterPanelContent>
                {props.children}
                <FilterPanelFooter horizontalAlign="center" verticalAlign="center">
                    {!!props.countText && <FilteredCountText>{props.countText}</FilteredCountText>}
                </FilterPanelFooter>
            </FilterPanelStack>
        </SlidingPanel>
    );
}
